import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercardSquare = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 37,
			height: 37,
			rx: 7.5,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 37,
			height: 37,
			rx: 7.5,
			stroke: "#ECECEF"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_11042_233457)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M22.2448 13.168H15.7555V24.8281H22.2448V13.168Z",
					fill: "#FF5F00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.1675 18.9961C16.1675 16.7301 17.2182 14.567 18.9898 13.1661C15.7761 10.6322 11.1203 11.1884 8.58639 14.4228C6.05249 17.6365 6.60871 22.2923 9.84305 24.8262C12.5418 26.9481 16.3117 26.9481 19.0104 24.8262C17.2182 23.4253 16.1675 21.2622 16.1675 18.9961Z",
					fill: "#EB001B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.0003 18.9961C31.0003 23.0957 27.6836 26.4125 23.584 26.4125C21.9153 26.4125 20.3085 25.8562 19.0106 24.8262C22.2244 22.2923 22.7806 17.6365 20.2467 14.4022C19.8759 13.9489 19.4638 13.5163 19.0106 13.1661C22.2244 10.6322 26.9007 11.1884 29.4141 14.4228C30.4441 15.7206 31.0003 17.3275 31.0003 18.9961Z",
					fill: "#F79E1B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.2998 23.5931V23.3459H30.4028V23.3047H30.1556V23.3459H30.2586V23.5931H30.2998ZM30.7736 23.5931V23.3047H30.6912L30.6088 23.5107L30.5264 23.3047H30.444V23.5931H30.5058V23.3665L30.5882 23.5519H30.65L30.7324 23.3665V23.5931H30.7736Z",
					fill: "#F79E1B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_11042_233457",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 14.8326,
				fill: "white",
				transform: "translate(7 11.582)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgMastercardSquare);
export { ForwardRef as ReactComponent };
